import { get } from '.';

export function GetSales(options = {}) {
	return get<any>("/app/api/sales", options);
}
